import parseHTML from 'html-react-parser';
import Badge from '../../../../../components/ui/Badge';
import { customDateFormatInSpanish } from '../../../../../utils/dates';
import {
	removeEmptyParagraphsbyQuill,
	convertFirebaseTSToDate
} from '../../../../../utils/helpers';
import QuestionContainerHeader from './QuestionContainerHeader';
import QuestionIssues from './QuestionIssues';
import QuestionTags from './QuestionTags';
import type {
	Category,
	Question
} from '../../../../../data/interface-question';
import './questions.css';
import type { QuestionBankID } from '../../../../../data/interface-question-bank';

interface IQuestionContainer {
	categories: Category[];
	question: Question;
	questionBankID: QuestionBankID;
	sortBy: 'create-desc' | 'create-asc' | 'modified-desc' | 'modified-asc';
}

const QuestionCard = ({
	categories,
	question,
	questionBankID,
	sortBy
}: IQuestionContainer) => {
	return (
		<div className='divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-md mb-4 text-sky-800 transition-all duration-200 hover:shadow-lg hover:scale-[1.01] hover:border hover:border-brand-200'>
			<QuestionContainerHeader
				question={question}
				questionBankID={questionBankID}
			/>
			<div className='px-4 sm:px-6 py-2'>
				<div className='flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 mb-2'>
					<Badge
						title={question.id}
						textColor='text-orange-500'
						ringColor='ring-orange-500/30'
					/>
					<div className='flex flex-wrap items-center gap-x-2 text-xs'>
						{question.createdOn !== undefined &&
							question.createdOn !== null && (
								<span
									className={`${
										sortBy.includes('create')
											? 'text-gray-600'
											: 'text-gray-400'
									}`}>
									Created:{' '}
									{customDateFormatInSpanish(
										convertFirebaseTSToDate(question.createdOn)
									)}
								</span>
							)}
						<span
							className={`${
								sortBy.includes('modified') ? 'text-gray-600' : 'text-gray-400'
							}`}>
							|{' '}
							{question.lastEditDate !== undefined &&
							question.lastEditDate !== null ? (
								<>
									Modified:{' '}
									{customDateFormatInSpanish(
										convertFirebaseTSToDate(question.lastEditDate)
									)}
								</>
							) : (
								<>Not modified</>
							)}
						</span>
					</div>
				</div>
				<article className='text-gray-700 text-sm break-words normal-bullets'>
					{parseHTML(removeEmptyParagraphsbyQuill(question.question))}
				</article>
			</div>
			<div className='px-4 sm:px-6 py-2 w-full'>
				<QuestionIssues issues={question.issues} />
				<QuestionTags categories={categories ?? []} tags={question.tags} />
			</div>
		</div>
	);
};
export default QuestionCard;
